import { z } from 'zod/v4';

export const GetAssetAccessControlParamsSchema = z.object({
  assetId: z.string().min(1),
});

export type GetAssetAccessControlParams = z.infer<
  typeof GetAssetAccessControlParamsSchema
>;

export const CompanyProfileSummarySchema = z
  .object({
    forCompanyId: z.string(),
    byCompanyId: z.string(),
    displayName: z.string().nullable(),
  })
  .nullable();

export type CompanyProfileSummary = z.infer<typeof CompanyProfileSummarySchema>;

export const AssetAccessControlSharedWithEntrySchema = z.object({
  sharedWithCompanyId: z.string(),
  assetId: z.string(),
  assetType: z.string(),
  rights: z.array(z.string()),
  status: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  companyProfile: CompanyProfileSummarySchema,
});

export const AssetAccessControlResponseSchema = z.object({
  assetId: z.string(),
  assetType: z.string(),
  ownedByCompanyId: z.string(),
  sharedWithCompanyId: z.string(),
  sharedByCompanyId: z.string(),
  rights: z.array(z.string()),
  status: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  sharedByCompanyProfile: CompanyProfileSummarySchema,
  ownedByCompanyProfile: CompanyProfileSummarySchema,
  sharedWith: z.array(AssetAccessControlSharedWithEntrySchema),
});

export type AssetAccessControlResponse = z.infer<
  typeof AssetAccessControlResponseSchema
>;
